export const ProductComparison = "eff5b5095910c0de39274c94be225734cc4c6217509c57013a55fb35c75f9662";